import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import client from '../Contentful_API/api';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import { SimpleShareButtons } from "react-simple-share";
import {Link} from 'react-router-dom'
import "./styles.css";

const SocialShare = () => (
    <SimpleShareButtons
      whitelist={["Facebook", "Twitter", "LinkedIn", "Google+"]}
      size="20px"
    />
  );

  

const muiBaseTheme = createMuiTheme();
const theme = {
  overrides: {
    MuiCard: {
      root: {
        "&.MuiEngagementCard--01": {
          transition: "0.3s",
          maxWidth: 300,
          margin: "auto",
          boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
          "&:hover": {
            boxShadow: "0 30px 70px -12.125px rgba(0,0,0,0.5)"
          },
          "& .MuiCardMedia-root": {
            paddingTop: "56.25%"
          },
          "& .MuiCardContent-root": {
            textAlign: "left",
            padding: muiBaseTheme.spacing.unit * 3
          },
          "& .MuiDivider-root": {
            margin: `${muiBaseTheme.spacing.unit * 3}px 0`
          },
          "& .MuiTypography--heading": {
            fontWeight: "bold"
          },
          "& .MuiTypography--subheading": {
            lineHeight: 1.8
          },
          "& .MuiAvatar-root": {
            display: "inline-block",
            border: "2px solid white",
            "&:not(:first-of-type)": {
              marginLeft: -muiBaseTheme.spacing.unit
            }
          }
        }
      }
    }
  }
};

function TreasuryDocumentContent(props) {
  return (
      props.publications? (
        <MuiThemeProvider theme={createMuiTheme(theme)}>
        <div className="App">
        <Link onClick={() => {window.location.href="/publicationdetails/"+ props.publications.fields.slug}} style={{ textDecoration: 'none' }}>
          <Card className={"MuiEngagementCard--01"}>
            <CardMedia
              image={props.publications.fields.publicationmedia.fields.file.url}
            />
            <CardContent>
              <Typography
                 className="text"
                variant={"h6"}
                gutterBottom
              >
                  {props.publications.fields.title}
              </Typography>
              <Typography
                className={"MuiTypography--subheading"}
                variant={"caption"}
              >
              </Typography>
              <Divider light />
              <SocialShare
                    url = {"https://www.mof.gov.tl/publicationdetails/" + props.publications.fields.slug }
                />
            </CardContent>
          </Card>
          </Link>
        </div>
      </MuiThemeProvider>
      ) : "No Publications" 
  )
}




class TreasuryDocument extends Component {

    state = {
        publications: [],
        searchString: ''
    }
    constructor() {
        super()
        this.getPublications()
    }
    getPublications = () => {
        client.getEntries({
            content_type: 'publications', 'fields.filesowner': 'treasury',
            query: this.state.searchString,

        })
        .then((response) => {
            this.setState({publications: response.items, loading: false})
            console.log(this.state.publications)
        })
        .catch((error) => {
          console.log("Error occurred while fetching Entries")
          console.error(error)
        })
    }
    onSearchInputChange = (event) => {
        console.log("Search changed ..." + event.target.value)
        if (event.target.value) {
            this.setState({searchString: event.target.value})
        } else {
            this.setState({searchString: ''})
        }
        this.getPublications()
    }
    render() {
        return (
            <div>
                { this.state.publications ? (
                    <div>
                        <TextField style={{padding: 24}}
                            id="searchInput"
                            placeholder="Search for Publications"   
                            margin="normal"
                            onChange={this.onSearchInputChange}
                            />
                        <Grid container spacing={2} style={{padding: 24}}>
                            { this.state.publications.map(currentPublications => (
                               <Grid item xs={12} sm={3} lg={3} xl={3}>
                                    <TreasuryDocumentContent publications={currentPublications} />
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                ) : "No Publications found" }
            </div>
        )
    }   
}

export default TreasuryDocument;
